<template>
  <div class="relative">
    <img src="@/assets/images/line/Vector 9.png" alt="lineimg" class="m-auto" />
    <div class="lg:flex md:flex justify-center">
      <div
        class="borderprimary bg-white lg:p-4 md:p-4 mob-pt-3 absolute lg:ml-0 md:ml-0 ml-12 lg:top-32 md:top-32 top-4 rounded-2xl lg:w-auto md:w-auto w-3/4 m-auto"
      >
        <div class="bgcceff2 rounded-2xl">
          <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
            <p class="font-semibold text-black fsize20 sm-fsize14">
              Request a call back
            </p>
            <div
              class="md:pl-12 lg:pl-14 pl-0 items-center flex lg:mx-auto md:mx-auto mob-justify-center"
            >
              <!-- <a
                href="https://forms.office.com/r/fA03Z0WhPj"
                > -->

              <base-button
                @click="handleRoute('request-form', 'other-issue')"
                type="primary"
                class="py-2 px-8 text-base font-bold border-2 mt-2 md:mt-0 lg:mt-0 whitespacenowrap mx-auto md:w-auto lg:w-auto w-full"
                >Fill Form</base-button
              >
              <!-- </a
              > -->
              <!-- @click="
                  isLoggedIn
                    ? handleregister('services')
                    : handleregister('register')
                " -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  methods: {
    handleregister(name) {
      this.$router.push({ name: name });
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.user && this.user._id != null;
    },
  },
};
</script>
<style></style>
